import { FC, useState } from 'react';
import { useAdminDiscounts } from 'store/admin-discounts';
import { SelectFilter, SelectFilterProps } from 'components/filters';

type Props = Omit<
  SelectFilterProps<string, true>,
  'options' | 'loadingOptions' | 'asyncSearch' | 'onSearch' | 'multiple'
>;

export const AdminDiscountsFilter: FC<Props> = (props) => {
  const [search, setSearch] = useState('');

  const { data: discounts, isLoading } = useAdminDiscounts({
    search,
  });

  return (
    <SelectFilter
      {...props}
      options={discounts?.items.map((discount) => ({
        key: discount.id,
        label: discount.name,
      }))}
      loadingOptions={isLoading}
      onSearch={setSearch}
      multiple
      asyncSearch
    />
  );
};
